// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__footer"};


//////////////////
// WEBPACK FOOTER
// ./src/components/footer/footer.scss
// module id = 1225
// module chunks = 0